export default [
  {
    path: '/coordinador/pensums',
    name: 'coordinador-pensums',
    component: () => import('@/views/pensums/PensumsView.vue'),
    meta: {
      resource: 'CoordinadorSubject',
      action: 'manage',
    },
  },
  {
    path: '/coordinador/competencies',
    name: 'coordinador-competencies',
    component: () => import('@/views/competencies/CompetenciesView.vue'),
    meta: {
      resource: 'CoordinadorSubject',
      action: 'manage',
    },
  },
  {
    path: '/coordinador/periods',
    name: 'coordinador-periods',
    component: () => import('@/views/periods/PeriodsView.vue'),
    meta: {
      resource: 'CoordinadorSubject',
      action: 'manage',
    },
  },
  {
    path: '/coordinador/scheduling',
    name: 'coordinador-scheduling',
    component: () => import('@/views/scheduling/SchedulingView.vue'),
    meta: {
      resource: 'CoordinadorSubject',
      action: 'manage',
    },
  },
  {
    path: '/coordinador/assignments',
    name: 'coordinador-assignments',
    component: () => import('@/views/assignments/AssignmentsView.vue'),
    meta: {
      resource: 'CoordinadorSubject',
      action: 'manage',
    },
  },
  {
    path: '/coordinador/evaluaciones/programar',
    name: 'coordinador-programar-evaluaciones',
    component: () => import('@/views/assignments/CalendarioEvaluacionFormView.vue'),
    meta: {
      resource: 'CoordinadorSubject',
      action: 'manage',
    },
  },
  {
    path: '/coordinador/evaluaciones/reporte',
    name: 'coordinador-reporte-evaluaciones',
    component: () => import('@/views/assignments/CalendarioEvaluacionesView.vue'),
    meta: {
      resource: 'CoordinadorSubject',
      action: 'manage',
    },
  },
  {
    path: '/coordinador/assignments-2',
    name: 'coordinador-assignments-2',
    component: () => import('@/views/assignments/CalendarioEvaluacionesView.vue'),
    meta: {
      resource: 'CoordinadorSubject',
      action: 'manage',
    },
  },
  {
    path: '/coordinador/assignments-3',
    name: 'coordinador-assignments-3',
    component: () => import('@/views/assignments/ReporteAsignacionCursosView.vue'),
    meta: {
      resource: 'CoordinadorSubject',
      action: 'manage',
    },
  },
  {
    path: '/coordinador/validations',
    name: 'coordinador-validations',
    component: () => import('@/views/validations/ValidationsView.vue'),
    meta: {
      resource: 'CoordinadorSubject',
      action: 'manage',
    },
  },
  {
    path: '/coordinador/carga-catedraticos',
    name: 'coordinador-carga-catedraticos',
    component: () => import('@/views/reports/CargaCatedraticosView.vue'),
    meta: {
      resource: 'CoordinadorSubject',
      action: 'manage',
    },
  },
]
